/**
 * Whether a coin flip is still news: made this turn or the one before (the opponent's flips happen on their turn,
 * and you see them on yours). Flips recorded before flips had a turn are old.
 *
 * @param {number|undefined} flipTurn the turn the flip was made in
 * @param {number} currentTurn        0 during setup
 */
export const isRecentFlip = (flipTurn, currentTurn) => flipTurn !== undefined && flipTurn !== null
  && flipTurn >= currentTurn - 1;
